import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const UserSquareIcon = createIcon({
  displayName: 'UserSquareIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M17.229,18.332l-0.318,-0.798c-0.161,-0.405 -0.41,-0.768 -0.73,-1.064l-0.058,-0.054c-0.503,-0.466 -1.163,-0.726 -1.849,-0.726h-4.55c-0.686,0 -1.347,0.26 -1.85,0.725l-0.058,0.054c-0.319,0.296 -0.568,0.659 -0.73,1.064l-0.316,0.799" />
        <path d="M14.246,7.93c1.24,1.24 1.24,3.251 0,4.492c-1.24,1.241 -3.251,1.24 -4.492,0c-1.241,-1.24 -1.24,-3.251 0,-4.492c1.24,-1.241 3.251,-1.24 4.492,-8.88178e-16" />
        <path d="M19,21h-14c-1.105,0 -2,-0.895 -2,-2v-14c0,-1.105 0.895,-2 2,-2h14c1.105,0 2,0.895 2,2v14c0,1.105 -0.895,2 -2,2Z" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0,0h24v24h-24v-24Z" />
    </>
  ),
})

const UserSquare: FC<IconProps> = (props) => {
  return <CustomIcon as={UserSquareIcon} {...props} />
}

export default memo(UserSquare)
